import React from 'react';
import { X, MapPin } from 'lucide-react';

const LocationTypeModal = ({ onClose, onCurrentLocation, onManualLocation }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={onClose}>
            {/* Modal pequeno e simples */}
            <div
                className="bg-white w-full max-w-xs rounded-2xl shadow-lg animate-slide-up"
                onClick={(e) => e.stopPropagation()}
            >
                <header className="p-4 border-b text-center relative">
                    <h2 className="text-lg font-bold text-gray-800">Opções de Localização</h2>
                    <button onClick={onClose} className="absolute top-1/2 right-2 -translate-y-1/2 p-2 rounded-full hover:bg-gray-200">
                        <X className="w-5 h-5" />
                    </button>
                </header>

                <main className="p-2">
                    {/* Opções como itens de lista */}
                    <button
                        onClick={onCurrentLocation}
                        className="w-full flex items-center p-3 text-left text-gray-700 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
                    >
                        <MapPin className="w-5 h-5 mr-3 text-blue-500" />
                        Localização Atual
                    </button>
                    <button
                        onClick={onManualLocation}
                        className="w-full flex items-center p-3 text-left text-gray-700 font-semibold rounded-lg hover:bg-gray-100 transition-colors"
                    >
                        <MapPin className="w-5 h-5 mr-3 text-gray-500" />
                        Inserir Localização
                    </button>
                </main>
            </div>
        </div>
    );
};

export default LocationTypeModal;
